import { createTabSlice } from '../helpers';

const tabs = [
  {
    id: 'dataCollections',
    label: 'Data Collections',
    icon: 'CollectionsBookmarkIcon',
    component: 'ViewData/DataCollections',
  },
  {
    id: 'patients',
    label: 'Patients',
    icon: 'AccessibleForwardIcon',
    component: 'ViewData/Patients',
  },
  {
    id: 'rawSequences',
    label: 'Raw Sequences',
    icon: 'LinearScaleIcon',
    component: 'ViewData/RawSequences',
  },
  {
    id: 'sequenceIntervals',
    label: 'Sequence Intervals',
    icon: 'CallSplitIcon',
    component: 'ViewData/SequenceIntervals',
  },
  {
    id: 'labels',
    label: 'Labels',
    icon: 'LabelIcon',
    component: 'ViewData/Labels',
  },
];

export const tabSlice = createTabSlice({ name: 'viewData/tabs', tabs });
